import { cn } from '../../utils'
import './Table.css'

interface TableScrollContainerProps {
    children: React.ReactNode
    className?: string
    disableOverflow?: boolean
}

export const TableScrollContainer = ({
    children,
    className,
    disableOverflow,
}: TableScrollContainerProps) => {
    return (
        <div
            className={cn(
                !disableOverflow && 'min-w-0 pr-2 sm:pr-4',
                className
            )}
        >
            {children}
        </div>
    )
}
